/**
 * @generated SignedSource<<d069e2dae6e7d3a38a148c18043a9f6a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type ArchitectureType = "AMD64" | "ARM64" | "%future added value";
export type PlatformType = "DARWIN" | "FREEBSD" | "LINUX" | "NETBSD" | "OPENBSD" | "SOLARIS" | "WINDOWS" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type MonthlyUsageChart_info$data = {
  readonly monthlyComputeUsage: ReadonlyArray<{
    readonly date: string;
    readonly usageDetails: ReadonlyArray<{
      readonly balanceInMicroCredits: number;
      readonly cpuSeconds: number;
      readonly instanceArchitecture: ArchitectureType;
      readonly instancePlatform: PlatformType;
    }>;
  }>;
  readonly " $fragmentType": "MonthlyUsageChart_info";
};
export type MonthlyUsageChart_info$key = {
  readonly " $data"?: MonthlyUsageChart_info$data;
  readonly " $fragmentSpreads": FragmentRefs<"MonthlyUsageChart_info">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MonthlyUsageChart_info",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "MonthlyComputeUsage",
      "kind": "LinkedField",
      "name": "monthlyComputeUsage",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "date",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "ComputeUsage",
          "kind": "LinkedField",
          "name": "usageDetails",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "instancePlatform",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "instanceArchitecture",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cpuSeconds",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "balanceInMicroCredits",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "OwnerInfo",
  "abstractKey": null
};

(node as any).hash = "9b82bf81e5a8c9d4949c7e030c9b9abd";

export default node;
